import React, { useState } from "react";
import DatePicker from "react-datepicker";
import { ButtonGroup, Form, ToggleButton } from "react-bootstrap";
import Input from "../Builder/nodes/Logic/Inputs/Input";
import HelpButton from "../HelpContent/HelpButton";

function MonitorDetails({ monitor, setMonitor, backendErrors }) {
  return (
    <div className="align-items-center rounded-3 p-4 bg-purple-gradient-darker-reverse px-5 mx-auto">
      <div>
        <span className="fs-4 fw-bold">
          Monitor Details
          <HelpButton helpKey="monitoring-details" />
        </span>
      </div>
      <div className="text-secondary">
        Complete the details below to create a profile for this Monitor
      </div>
      <div>
        <span className="fw-bold">Boom Reference :</span>
        <span className="text-secondary ms-1">
          {monitor.Uuid ||
            "Your ref will be available once you save the monitor."}
        </span>
      </div>
      {monitor.CreatedBy && (
        <div>
          <span className="fw-bold">Created by :</span>
          <span className="text-secondary ms-1">{monitor.CreatedBy}</span>
        </div>
      )}
      <div className=" mt-3">
        <div className="row">
          <div className="col-6">
            <Form.Group className="mb-3" controlId="referenceMonitor">
              <Form.Label className="fw-bold">
                Customer Reference :
                <HelpButton helpKey="monitoring-customer-reference" />
              </Form.Label>
              <Form.Control
                type="text"
                value={monitor.Reference || ""}
                onChange={(e) =>
                  setMonitor({ ...monitor, Reference: e.target.value })
                }
              />
            </Form.Group>
          </div>
          <div className="col-6">
            <Form.Group className="mb-3" controlId="monitorTitle">
              <Form.Label className="fw-bold">
                Title:
                <HelpButton helpKey="monitoring-title" />
              </Form.Label>
              <Form.Control
                type="text"
                value={monitor.Label || ""}
                onChange={(e) =>
                  setMonitor({ ...monitor, Label: e.target.value })
                }
              />
              {backendErrors?.["Monitor.Label"] && (
                <div className="alert alert-danger p-1 mt-2">
                  {backendErrors?.["Monitor.Label"]}
                </div>
              )}
            </Form.Group>
          </div>{" "}
        </div>
        <div>
          <Form.Group className="mb-3" controlId="monitorDescription">
            <Form.Label className="fw-bold">
              Description:
              <HelpButton helpKey="monitoring-description" />
            </Form.Label>
            <Form.Control
              as="textarea"
              rows={4}
              value={monitor.Description || ""}
              onChange={(e) =>
                setMonitor({ ...monitor, Description: e.target.value })
              }
            />
            {backendErrors?.["Monitor.Description"] && (
              <div className="alert alert-danger p-1 mt-2">
                {backendErrors?.["Monitor.Description"]}
              </div>
            )}
          </Form.Group>
        </div>
        <div className="row">
          <div className=" col-6 ">
            <div>
              <Form.Group controlId="priorityMonitor">
                <Form.Label className="fw-bold me-2">
                  Priority:
                  <HelpButton helpKey="monitoring-priority" />
                </Form.Label>
                <span className="text-secondary small">
                  Select the color for urgency of the monitor.
                </span>
              </Form.Group>
            </div>
            <div>
              <ButtonGroup>
                <ToggleButton
                  id="radio-priority-low"
                  className={`bg-success text-white border-0 ${
                    monitor.Priority === "low"
                      ? "bg-opacity-100"
                      : "bg-opacity-25"
                  }`}
                  type="radio"
                  variant=""
                  name="radio-priority"
                  checked={monitor.Priority === "low"}
                  onChange={() => setMonitor({ ...monitor, Priority: "low" })}
                >
                  Low
                </ToggleButton>
                <ToggleButton
                  id="radio-priority-medium"
                  type="radio"
                  variant=""
                  className={`bg-warning text-white border-0 ${
                    monitor.Priority === "medium"
                      ? "bg-opacity-100"
                      : "bg-opacity-25"
                  }`}
                  name="radio-priority"
                  checked={monitor.Priority === "medium"}
                  onChange={() =>
                    setMonitor({ ...monitor, Priority: "medium" })
                  }
                >
                  Medium
                </ToggleButton>
                <ToggleButton
                  id="radio-priority-high"
                  type="radio"
                  variant=""
                  className={`bg-danger text-white border-0 ${
                    monitor.Priority === "high"
                      ? "bg-opacity-100"
                      : "bg-opacity-25"
                  }`}
                  name="radio-priority"
                  checked={monitor.Priority === "high"}
                  onChange={() => setMonitor({ ...monitor, Priority: "high" })}
                >
                  High
                </ToggleButton>
              </ButtonGroup>
            </div>
          </div>
          <div className="col-6">
            <Form.Group className="" controlId="statusMonitor">
              <Form.Label className="fw-bold me-2">
                Status:
                <HelpButton helpKey="monitoring-status" />
              </Form.Label>
            </Form.Group>
            <Input
              value={[monitor.Status]}
              onChange={(v) => {
                setMonitor({ ...monitor, Status: v[0] });
              }}
              inputType="radio"
              options={[
                { value: "active", label: "ACTIVE" },
                { value: "draft", label: "DRAFT" },
                { value: "archived", label: "ARCHIVED" },
              ]}
            />
          </div>
        </div>
        <div>
          <Form.Group className="mb-3" controlId="startMonitor">
            <Form.Label className="fw-bold">
              Start:
              <HelpButton helpKey="monitoring-start" />
            </Form.Label>
            {!monitor?.StartAt ||
            monitor?.StartAt === "0001-01-01T00:00:00Z" ? null : (
              <span className="text-secondary ms-2">
                Leave empty to start immediately{" "}
              </span>
            )}
            <DatePicker
              placeholderText="Leave empty to start immediately"
              isClearable
              className="form-control w-100"
              showTimeSelect
              selected={
                !monitor?.StartAt || monitor?.StartAt === "0001-01-01T00:00:00Z"
                  ? null
                  : new Date(monitor?.StartAt)
              }
              onChange={(date) => {
                if (!date) {
                  setMonitor({ ...monitor, StartAt: "0001-01-01T00:00:00Z" });
                  return;
                }
                setMonitor({ ...monitor, StartAt: date.toISOString() });
              }}
              dateFormat="yyyy-MM-dd HH:mm"
              maxDate={monitor?.EndAt ? new Date(monitor?.EndAt) : null}
            />
          </Form.Group>
        </div>
        <div>
          <Form.Group className="mb-3" controlId="endMonitor">
            <Form.Label className="fw-bold">
              End:
              <HelpButton helpKey="monitoring-end" />
            </Form.Label>
            {!monitor?.EndAt ||
            monitor?.EndAt === "0001-01-01T00:00:00Z" ? null : (
              <span className="text-secondary ms-2">
                Leave empty to run indefinitely
              </span>
            )}
            <DatePicker
              placeholderText="Leave empty to run indefinitely"
              isClearable
              className="form-control w-100"
              showTimeSelect
              selected={
                !monitor?.EndAt || monitor?.EndAt === "0001-01-01T00:00:00Z"
                  ? null
                  : new Date(monitor?.EndAt)
              }
              onChange={(date) => {
                if (!date) {
                  setMonitor({ ...monitor, EndAt: "0001-01-01T00:00:00Z" });
                  return;
                }
                setMonitor({ ...monitor, EndAt: date.toISOString() });
              }}
              dateFormat="yyyy-MM-dd HH:mm"
              minDate={monitor?.StartAt ? new Date(monitor?.StartAt) : null}
            />
          </Form.Group>
        </div>
      </div>
    </div>
  );
}

export default MonitorDetails;
